import client from './client';

export default {
  fetch(params) {
    return client.get('/payments/details/display')
      .send(params)
      .end();
  },
  updatePaymentDetails(params) {
    return client.post('/payments/billing_details/update')
      .send(params)
      .end();
  },
  cardReplace(params) {
    return client.post('/payments/cards/update')
      .send(params)
      .end();
  },
  renewSubscription() {
    return client.post('/payments/subscriptions/renew')
      .end();
  },
  cancelSubscription() {
    return client.post('/payments/subscriptions/unsubscribe')
      .end();
  }
};



// WEBPACK FOOTER //
// ./app/sources/api/paymentDetailsAPI.js